import Button from "@Components/Button";
import LazyImage from "@Components/Image";
import config from "@Config/index";
import getImagePath from "@Utils/getImagePath";
import formatClassNames from "@Utils/clientUtils/stringUtility/formatClassNames";
import wrapperHOC from "@Utils/wrapperHOC";
import useIsDesktop from "hooks/useIsDesktop";
import styles from "./GroupBookingSection.module.scss";

const AVATAR_SRC = getImagePath(`${config.IMAGE_STATIC_URL}/images/AvatarsGroupBooking.png`);

const GroupBookingSection = () => {
  const isDesktop = useIsDesktop();

  return (
    <div className={formatClassNames(styles.container, !isDesktop && styles.containerMobile)}>
      <LazyImage
        src={AVATAR_SRC}
        alt="Group Booking Avatars"
        className={styles.avatarImage}
        width={120}
        height={48}
      />
      <div className={styles.title}>团体预订可节省高达¥200</div>
      <div className={styles.subtitle}>一群学生通过团体预订已经节省了很多钱！</div>
      <Button
        variant="primary"
        className={styles.ctaButton}
        onClick={() => {
          window.location.href = "https://amberstudent.cn/group-booking";
        }}
      >
        开始团购
      </Button>
    </div>
  );
};

export default wrapperHOC(GroupBookingSection, {
  componentName: "GroupBookingSection-PropertyPage",
  showForChina: true,
});
